import { useNavigate } from 'react-router-dom';
import { ArrowRight, UserPlus } from 'react-feather';
import TablaServidor from '../../components/tabla/TablaServidor';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';
import colors from '../../theme/colors';
import { COLUMNAS_CLIENTES, TABLA_CLIENTES } from '../../components/clientes/columnasClientes';

const ListadoClientes = () => {
  useTituloCabecera('Clientes', 'Gestiona y busca clientes del sistema');
  const navigate = useNavigate();
  const abrir = (f) => navigate(`/clientes/${f.empresaId}/${f.codigo}/detalles`);

  const nuevo = (
    <button
      type="button"
      onClick={() => navigate('/clientes/nuevo')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '7px 14px',
        fontSize: '0.8125rem',
        fontWeight: 600,
        borderRadius: 8,
        border: 0,
        cursor: 'pointer',
        background: colors.primary,
        color: '#fff',
      }}
    >
      <UserPlus size={14} />
      Nuevo
    </button>
  );

  return (
    <TablaServidor
      tablaKey={TABLA_CLIENTES}
      columnas={COLUMNAS_CLIENTES}
      ruta="listado-clientes"
      archivo="clientes"
      nombreEntidad="clientes"
      placeholder="Buscar por nombre, CIF, email o código…"
      barraExtra={nuevo}
      claveFila={(f) => `${f.empresaId}-${f.codigo}`}
      onFilaClick={abrir}
      renderAcciones={(f) => (
        <button
          type="button"
          className="tbl-icono"
          aria-label="Detalles"
          title="Ver detalles"
          onClick={(e) => {
            e.stopPropagation();
            abrir(f);
          }}
        >
          <ArrowRight size={15} />
        </button>
      )}
      tituloTarjeta={(f) => f.nombreFiscal || `#${f.codigo}`}
    />
  );
};

export default ListadoClientes;
